import { render, staticRenderFns } from "./eduDrvSessions.vue?vue&type=template&id=844c2646&scoped=true&"
import script from "./eduDrvSessions.vue?vue&type=script&lang=js&"
export * from "./eduDrvSessions.vue?vue&type=script&lang=js&"
import style0 from "./eduDrvSessions.vue?vue&type=style&index=0&id=844c2646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844c2646",
  null
  
)

export default component.exports